import { Injectable, signal } from "@angular/core";
import { v4 as uuidv4 } from "uuid";

@Injectable({
  providedIn: "root",
})
export class SessionService {
  private sessionId = signal<string>("");

  generateSessionId(): string {
    this.sessionId.set(uuidv4());
    return this.sessionId();
  }

  getSessionId(): string {
    return this.sessionId();
  }

  clearSessionId(): void {
    this.sessionId.set("");
  }
}
